import { memo } from "react";
import { Box } from "@/components";
import { PositionTypeSelector } from "./filter/PositionTypeSelector";
import { usePortfolioStore } from "@/zustand/PortfolioStore";
import { LockedPositionsTable } from "./table/locked/LockedPositionsTable";
import { StakedPositionsTable } from "./table/staked/StakedPositionsTable";
import { BoostYield } from "./BoostYield";

export const PortfolioPositionsSection = memo(() => {
    const { positionType } = usePortfolioStore();
    return (
        <Box className="gap-6 rounded-[8px] p-[36px] border-primary/20 border-[1px]" card shadow>
            <h2 className="text-primary text-[24px] leading-[28px] font-medium">Positions</h2>
            <PositionTypeSelector />
            {positionType === "locked" ? (
                <>
                    <BoostYield />
                    <LockedPositionsTable />
                </>
            ) : (
                <StakedPositionsTable />
            )}
        </Box>
    );
});

PortfolioPositionsSection.displayName = "PortfolioPositionsSection";
